// api
import { fetchApi } from '@/api'
// actions
const inventoryReportsAll = (context) => {
  let url = 'inventory/reports'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryReportsForm = (context) => {
  let url = 'inventory/reports/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_REPORTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryReportsShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/reports/' + obj.id + '/edit'
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_REPORTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const inventoryReportsCreate = (context, payload) => {
  let url = 'inventory/reports'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_REPORTS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryReportsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/providers/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('INVENTORY_REPORTS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryReportsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/providers/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('INVENTORY_REPORTS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  inventoryReportsAll,
  inventoryReportsForm,
  inventoryReportsShow,
  inventoryReportsCreate,
  inventoryReportsUpdate,
  inventoryReportsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/reports/actions.js